import { createReactComponent } from '@tabler/icons-react';

export const IconCustomAsteriskOff = createReactComponent(
  'outline',
  'customAsteriskOff',
  'CustomAsteriskOff',
  [
    [
      'path',
      {
        key: 'customAsteriskOff-path',
        d: 'M12,12v8.8 M12,12L4.2,7.6 M12,12l-7.8,4.4 M19.8,7.6c0,0-3.3,1.9-5.3,3.1 M20.5,16.4l-0.9-0.5 M12,3.2v5M3.2,3.2l17.5,17.5',
      },
    ],
  ]
);
